import { defineStore } from "pinia";
import Cookies from "js-cookie";
import { SalesmanApi } from "@/services/Api";
import { ISalesman } from "@/models/ISalesman";
import { Salesman } from "@/models/Salesman";

export const useChosenSalesman = defineStore("chosen-salesman", {
  state: (): ISalesman => {
    return new Salesman();
  },
  actions: {
    async load(): Promise<void> {
      const postalCode = Cookies.get("postal-code");
      //We need to send a request even if postalCode is null because the user might have a district code
      const res = await SalesmanApi.setPostalCookieAndGetSalesman(postalCode);
      this.$patch({ ...res });
    },
    async update(postalCode: string): Promise<void> {
      if (postalCode) {
        const res = await SalesmanApi.setPostalCookieAndGetSalesman(postalCode);
        this.$patch({ ...res });
      }
    },
  },
});
